import * as React from "react";
import styled from "styled-components";
import { Text } from "@origin-digital/ods-core";
import { IconProperty } from "@origin-digital/ods-icons";

const AddressLineContainer = styled.div`
  display: flex;
  flex-direction: row;
  > :first-child {
    margin-right: 8px;
  }
`;

interface AddressLineProps {
  address: string;
}

const StyledIcon = styled((props) => <IconProperty {...props} />)`
  && {
    font-size: 20px;
    color: ${(p) => p.theme.colors.grey400};
  }
`;

export const AddressLine = ({ address }: AddressLineProps) => {
  return (
    <AddressLineContainer data-id="action-bar-address-line">
      <StyledIcon />
      <Text variant="body-small" data-id="action-bar-address-line-text">
        {address}
      </Text>
    </AddressLineContainer>
  );
};
